import style from "./style.module.scss";
import ImagePair from "./ImagePair";
import SingleImage from "./SingleImage";
import VideoPart from "./VideoPart";
import PinkSlogan from "./PinkSlogan";

import VideoPlayer from "../InfoPages/PageContent/VideoPlayer";
import Footer from "../InfoPages/PageContent/Footer";

export default function Team() {
    return <div className={style.root}>

        <div className={style.backedCnt}>
            <VideoPlayer full />
            <div className={style.topBackground} />
            <div className={style.container}>
                <div className={style.logo} style={{ backgroundImage: `url("/Images/vhenga.png")` }} />

                <div className={style.topText}>
                    <span className={style.link}>Mensen maken Vhenga.</span> Zij maken het heel graag voor <span className={style.link}>U</span> waar. Zij gaan <span className={style.link}>U</span> heel graag verder helpen. <span className={style.link}>Zij staan voor U klaar.</span>
                    {/* <span className={style.link}>Exclusief</span>, <span className={style.link}>discreet</span> en <span className={style.link}>anders</span>. Daar draait het bij Chapter om. Wij verkopen exclusief vastgoed, in alle discretie, op onze eigen manier. */}
                </div>
                <ImagePair />
                <SingleImage {...{ style }} />
                <VideoPart />
                {/* <ImagePair swap /> */}
            </div>
            <PinkSlogan {...{ style }} />
            <div className="row">
                <Footer />
            </div>
        </div>
    </div>
}